import { required } from "vuelidate/lib/validators";

export default class ProdutosValorData {
  id_faixa_revenda = "";

  boleto = 0;

  cartao_credito = 0;

  juros_boleto = "";

  juros_cartao_credito = "";

  qtd_parcelas_juros_boleto = "";

  qtd_parcelas_juros_cartao = "";

  constructor({
    id_faixa_revenda = "",
    cartao_credito = "",
    boleto = 0,
    juros_boleto = "",
    juros_cartao_credito = "",
    qtd_parcelas_juros_boleto = "",
    qtd_parcelas_juros_cartao = ""
  }) {
    this.cartao_credito = cartao_credito;
    this.id_faixa_revenda = id_faixa_revenda;
    this.boleto = boleto;
    this.juros_boleto = juros_boleto;
    this.juros_cartao_credito = juros_cartao_credito;
    this.qtd_parcelas_juros_boleto = qtd_parcelas_juros_boleto;
    this.qtd_parcelas_juros_cartao = qtd_parcelas_juros_cartao;
  }
}

export const ProdutosValorDataRequired = {
  boleto: {
    required
  },
  id_faixa_revenda: {
    required
  },
  cartao_credito: {
    required
  }
};
